module.exports = __webpack_public_path__ + "static/ganar-6178d4dd7bb65594095f1986c8783616.png";